<template>
  <div
    :class="
      classes(
        n(),
        n('$--box'),
        n(`--${state.size}`),
        n(`--theme-${theme}--${state.type}`),
        [(disabled || disabledStyle), n('--disabled')],
        [(disabled || disabledStyle), n(`--${state.type}-disabled`)],
      )
    "
    role="button"
    :tabindex="disabled || disabledStyle ? -1 : 0"
    :aria-disabled="disabled || disabledStyle"
    @click="handleClick"
  >
    <div :class="classes(n('content'))">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'virtual-vue';
import { DEFAULT_BUTTON_SIZE, DEFAULT_BUTTON_THEME, DEFAULT_BUTTON_TYPE, props } from './props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
const { name, n, classes } = createNamespace('button');

export default defineComponent({
  name,
  props,
  emits,
  setup(props, { emit }) {
    const state = computed(() => ({
      type: props.type ?? DEFAULT_BUTTON_TYPE,
      size: props.size ?? DEFAULT_BUTTON_SIZE,
      theme: props.theme ?? DEFAULT_BUTTON_THEME,
    }));

    function handleClick() {
      const { disabled } = props;
      if (disabled) {
        return;
      }
      emit('click');
    }

    return {
      state,
      n,
      classes,
      handleClick,
    };
  },
});
</script>
